import { useCallback } from "react";
import { useEventsApi } from "./useEventsApi";
import { NumberRangeStatus } from "../shared/NumberRangeStatus";
import { config } from "../config";

const FILL_STATUS_TTL_MS = 60_000;
let cachedFillStatus: { rows: NumberRangeStatus[]; fetchedAt: number } | null = null;
let fillStatusInflight: Promise<NumberRangeStatus[]> | null = null;

export async function fetchNumberRangeFillStatus(
  callApi: (url: string, method?: string) => Promise<unknown>,
  opts?: { force?: boolean }
): Promise<NumberRangeStatus[]> {
  if (opts?.force) {
    cachedFillStatus = null;
    fillStatusInflight = null;
  }
  if (
    !opts?.force &&
    cachedFillStatus &&
    Date.now() - cachedFillStatus.fetchedAt < FILL_STATUS_TTL_MS
  ) {
    return cachedFillStatus.rows;
  }
  if (fillStatusInflight) {
    return fillStatusInflight;
  }

  const url = new URL(`${config.apiUrl}/api/number-ranges/status/`).toString();
  fillStatusInflight = (async () => {
    const data = (await callApi(url, "GET")) as NumberRangeStatus[];
    const rows = Array.isArray(data) ? data : [];
    cachedFillStatus = { rows, fetchedAt: Date.now() };
    return rows;
  })();

  try {
    return await fillStatusInflight;
  } finally {
    fillStatusInflight = null;
  }
}

export const useRangeStatusApi = () => {
  const { callApi } = useEventsApi();

  const fetchRangeStatus = useCallback(
    (opts?: { force?: boolean }) => fetchNumberRangeFillStatus(callApi, opts),
    [callApi]
  );

  return { fetchRangeStatus };
};